import riskCategory from './riskCategory';
import { isASCE716or722 } from '__common/constants/buildingCodes';

export const getASCE716722LocationsResidentalAdditionalInputs = (buildingCode: number) => {
  return isASCE716or722(buildingCode) ? [riskCategory] : [];
};
